import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import SignatureCanvas from 'react-signature-canvas';
import '../css/Abonos.css';

const Abonos = () => {
  const [choferes, setChoferes] = useState([]);
  const [chofer, setChofer] = useState('');
  const [cantidad, setCantidad] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [mensaje, setMensaje] = useState('');
  const sigCanvas = useRef();

  useEffect(() => {
    const fetchChoferes = async () => {
      try {
        const res = await axios.get('https://deudas.transpoortessolorzano.com/choferes');
        setChoferes(res.data);
      } catch (error) {
        console.error('Error al cargar choferes:', error);
      }
    };
    fetchChoferes();
  }, []);

  const handleAbonoSubmit = async (e) => {
    e.preventDefault();

    if (!chofer || !cantidad || sigCanvas.current.isEmpty()) {
      setMensaje('Completa todos los campos y firma el recibido.');
      return;
    }

    const firmaBase64 = sigCanvas.current.getCanvas().toDataURL('image/png');

    try {
      await axios.post('https://deudas.transpoortessolorzano.com/abonos', {
        chofer_id: chofer,
        cantidad,
        descripcion,
        firma: firmaBase64
      });

      setMensaje('Abono registrado correctamente.');
      setChofer('');
      setCantidad('');
      setDescripcion('');
      sigCanvas.current.clear();
    } catch (error) {
      console.error('Error al guardar el abono:', error);
      setMensaje('Ocurrió un error al guardar el abono.');
    }
  };

  return (
    <div className="abonos-container">
      <h2 className="abonos-title">Registro de Abonos</h2>
      {mensaje && <p className="abonos-message">{mensaje}</p>}
      <form className="abonos-form" onSubmit={handleAbonoSubmit}>
        <label className="abonos-label">Chofer:</label>
        <select
          className="abonos-select"
          value={chofer}
          onChange={(e) => setChofer(e.target.value)}
        >
          <option value="">Selecciona un chofer</option>
          {choferes.map((c) => (
            <option key={c.id} value={c.id}>{c.nombre}</option>
          ))}
        </select>

        <label className="abonos-label">Cantidad abonada:</label>
        <input
          className="abonos-input"
          type="number"
          value={cantidad}
          onChange={(e) => setCantidad(e.target.value)}
          placeholder="Cantidad"
        />

        <label className="abonos-label">Motivo del abono:</label>
        <textarea
          className="abonos-textarea"
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value)}
          placeholder="Motivo o descripción"
        />

        <label className="abonos-label">Firma de recibido:</label>
        <div className="abonos-signature-box">
          <SignatureCanvas
            penColor="black"
            canvasProps={{
              width: 560,
              height: 150,
              className: 'signature-canvas'
            }}
            ref={sigCanvas}
          />
        </div>

        <button
          className="abonos-button"
          type="button"
          onClick={() => sigCanvas.current.clear()}
        >
          Limpiar firma
        </button>

        <br />

        <button className="abonos-button" type="submit">
          Guardar abono
        </button>
      </form>
    </div>
  );
};

export default Abonos;
